import React from 'react';
import PropTypes from 'prop-types';
import CheckboxTree from 'react-checkbox-tree';
import { connect } from 'react-redux';
import { getPermissionsTree } from '../../../redux/permissions/selectors';
import { PERMISSIONS_ACTIONS } from '../../../redux/permissions/actions';

class _PermissionsSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.default,
      expanded: []
    };

    this._checkedHandler = this._checkedHandler.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.permissionsRequest();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      checked: nextProps.default
    });
  }

  _checkedHandler(checked) {
    this.setState({ checked });
    this.props.onChange(checked);
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    touched: PropTypes.any,
    errors: PropTypes.any,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    help: PropTypes.string,
    default: PropTypes.array,
    permissions: PropTypes.array,
    permissionsRequest: PropTypes.func
  };

  render() {
    const { touched, errors, name, label, help, permissions } = this.props;
    const {checked, expanded} = this.state;

    return (
      <div>
        {label && <label htmlFor={name}>{label}</label>}

        {permissions.length > 0 && (
          <CheckboxTree
            nodes={permissions}
            checked={checked}
            expanded={expanded}
            onCheck={this._checkedHandler}
            onExpand={expanded => this.setState({ expanded })}
          />
        )}

        <div
          className={
            touched.permissions && errors.permissions
              ? 'form-group m-form__group has-danger'
              : 'form-group m-form__group'
          }
        >
          {help && <span className="m-form__help">{help}</span>}

          {touched.permissions && errors.permissions && (
            <div className="form-control-feedback">{errors.permissions}</div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  permissions: getPermissionsTree(state)
});

const mapDispatchToProps = dispatch => ({
  permissionsRequest: () => dispatch(PERMISSIONS_ACTIONS.loadAllRequest())
});

const PermissionsSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(_PermissionsSelector);

export default PermissionsSelector;
